var $0e57f960dda4ae5c$exports = {};
$0e57f960dda4ae5c$exports = {
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`
};


export {$0e57f960dda4ae5c$exports as default};
//# sourceMappingURL=et-EE.mjs.map
